import api, { backupApi, unifiedSyncApi } from './api';
import type { ApiResponse } from '../types';

export interface RobotRunStatus {
  key: string;
  label: string;
  isRunning: boolean;
  detail?: string;
  startedAt?: string;
  error?: string | null;
}

async function fetchRobotStatus(path: string): Promise<Record<string, unknown>> {
  const res = await api.get<ApiResponse<Record<string, unknown>>>(path);
  return res.data.data || {};
}

export const dashboardApi = {
  backupSummary: () => backupApi.getStatus(),
  syncSummary: () => unifiedSyncApi.status(),

  robotsSummary: async (): Promise<RobotRunStatus[]> => {
    const specs: { key: string; label: string; path: string }[] = [
      { key: 'brands', label: 'SEO брендов', path: '/generate/status' },
      { key: 'faq', label: 'FAQ брендов', path: '/generate/faq/status' },
      { key: 'categories', label: 'SEO категорий', path: '/generate/categories/status' },
      { key: 'branches', label: 'SEO веток', path: '/generate/branches/status' },
    ];
    const out: RobotRunStatus[] = [];
    await Promise.all(
      specs.map(async (s) => {
        try {
          const data = await fetchRobotStatus(s.path);
          const running = Boolean(data.isRunning);
          let detail = '';
          if (running && data.currentCategory) detail = String(data.currentCategory);
          else if (running && data.currentBrand) detail = String(data.currentBrand);
          else if (running && data.currentTree) detail = String(data.currentTree);
          else if (data.processedCategories != null && data.totalCategories != null) {
            detail = `${data.processedCategories} / ${data.totalCategories}`;
          }
          out.push({
            key: s.key,
            label: s.label,
            isRunning: running,
            detail: detail || undefined,
            startedAt: (data.startedAt as string) || undefined,
            error: (data.error as string) || null,
          });
        } catch {
          out.push({ key: s.key, label: s.label, isRunning: false, error: 'нет данных' });
        }
      })
    );
    return specs.map((s) => out.find((r) => r.key === s.key)!);
  },
};
